var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ninja-keys',{ref:"ninjaKeys",staticClass:"ninja-keys",attrs:{"placeholder":_vm.placeholder,"hidebreadcrumbs":true},on:{"selected":_vm.selected,"change":_vm.change}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }